import React, { ReactElement, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from 'src/store/hooks'
import { Box, Button } from '@mui/material'
import { LeftArrowIcon, RightArrowIcon } from 'src/v3/core/icons'
import {
  fetchEvents,
  fetchReferences,
  fetchSyllabus,
  selectActiveEvent,
  selectEventById,
  selectEventsStatus,
  selectReferences,
  selectReferencesStatus,
  selectSyllabusByEventID,
  selectSyllabusStatusByEventID,
} from './events.slice'
import { SyllabusBuilder } from '../components/syllabus-builder'
import { EventWizardStep } from './types'

let Quiz = ({
  setStep,
}: {
  setStep: React.Dispatch<React.SetStateAction<EventWizardStep>>
}): ReactElement => {
  let dispatch = useAppDispatch()
  let { eventId } = useParams()

  let event = eventId
    ? useAppSelector(selectEventById(eventId))
    : useAppSelector(selectActiveEvent)
  let eventsStatus = useAppSelector(selectEventsStatus)
  let eventID = event?.id || ''

  let syllabus = useAppSelector(selectSyllabusByEventID(eventID))
  let syllabusStatus = useAppSelector(selectSyllabusStatusByEventID(eventID))
  let references = useAppSelector(selectReferences)
  let referencesStatus = useAppSelector(selectReferencesStatus)

  useEffect(() => {
    if (eventsStatus === 'uninitialized') {
      dispatch(fetchEvents())
    }
  }, [eventsStatus])

  useEffect(() => {
    if (eventID && (!syllabusStatus || syllabusStatus === 'uninitialized')) {
      dispatch(fetchSyllabus(eventID))
    }
  }, [syllabusStatus, eventID])

  useEffect(() => {
    if (referencesStatus === 'uninitialized') {
      dispatch(fetchReferences())
    }
  }, [referencesStatus])

  let ButtonBar = ({ loading }: { loading: boolean }) => (
    <Box
      sx={{
        mt: 5,
        display: 'flex',
        justifyContent: 'space-between',
        gap: 1,
      }}
    >
      <Button
        sx={{ color: 'text.primary' }}
        startIcon={<LeftArrowIcon />}
        onClick={() => setStep('details')}
      >
        Previous: Event Details
      </Button>
      <Button
        variant="contained"
        type="submit"
        endIcon={<RightArrowIcon />}
        loading={loading}
      >
        Next: Sessions
      </Button>
    </Box>
  )

  return (
    <SyllabusBuilder
      syllabus={syllabus}
      fetchSyllabus={fetchSyllabus}
      content={{ kind: 'event', event: event || ({} as any) }}
      referenceLib={references}
      loadingStatuses={[eventsStatus, syllabusStatus, referencesStatus]}
      SubmitButton={ButtonBar}
      onSuccess={() => setStep('sessions')}
    />
  )
}

export default Quiz
